var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5 36.4c6.8 0 12.3-5.5 12.3-12.3s-5.5-12.3-12.3-12.3S9.2 17.3 9.2 24.1 14.7 36.4 21.5 36.4zM21.5 15.3c4.8 0 8.8 3.9 8.8 8.8 0 4.9-3.9 8.8-8.8 8.8s-8.8-3.9-8.8-8.8C12.7 19.2 16.6 15.3 21.5 15.3zM21.5 40.8c-7.3 0-14.3 3-19.7 8.4-.7.7-.7 1.8 0 2.5C2.1 52 2.6 52.2 3 52.2c.5 0 .9-.2 1.2-.5 4.7-4.8 10.8-7.4 17.2-7.4 6.3 0 12.4 2.6 17.2 7.4.7.7 1.8.7 2.5 0 .7-.7.7-1.8 0-2.5C35.7 43.8 28.7 40.8 21.5 40.8zM47.8 36.4c3.9 0 7-3.2 7-7s-3.2-7-7-7-7 3.2-7 7S43.9 36.4 47.8 36.4zM47.8 25.8c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5-3.5-1.6-3.5-3.5S45.9 25.8 47.8 25.8zM62.2 46.5c-5.3-5-12.7-6.9-20.1-5-.9.2-1.5 1.2-1.3 2.1.2.9 1.2 1.5 2.1 1.3 6.2-1.6 12.4 0 16.8 4.2.3.3.8.5 1.2.5.5 0 .9-.2 1.3-.6C62.9 48.3 62.9 47.2 62.2 46.5z"}));
}

Users.defaultProps = {"version":"1.1","viewBox":"0 0 64 64","x":"0","y":"0","xmlSpace":"preserve"};

module.exports = Users;

Users.default = Users;
